import { inject, Injectable } from '@angular/core';
import { managePlanBreadcrumbsConfigs } from './manage-plan-breadcrumbs.config';
import { BreadcrumbsService } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.service';

@Injectable()
export class ManagePlanAppConfigService {
  private readonly breadcrumbsService = inject(BreadcrumbsService);

  constructor() {
    this.breadcrumbsService.addBreadcrumbsData(managePlanBreadcrumbsConfigs);
  }

  readonly analyticsHierarchy = 'myaccount';
}
